import React from "react";
import { getInitialData } from "../service/apiFetch";
import ContentPage from "../components/utils/ContentPage";

export const getStaticProps = async () => {
  const initialData = await getInitialData("general-rules", {
    contentBlock: "Object",
  });

  return {
    props: {
      websiteData: initialData?.websiteData || "",
      data: initialData?.data || "",
      title: initialData?.title || "",
      metaTags: initialData?.metaTags || "",
      url: initialData?.url || "",
      error: initialData?.error || "",
    },
  };
};

export default function GeneralRules({ data }) {
  const block =
    data?.contentBlock?.GENERAL_RULES ||
    data?.contentBlock?.GENERAL_RULES_DATA ||
    data?.contentBlock?.RULES;
  return (
    <ContentPage
      heading={block?.heading}
      subHeading={block?.subHeading}
      content={block?.content}
    />
  );
}
